export * as categories from '@wix/auto_sdk_online-programs_categories/meta';
export * as instructors from '@wix/auto_sdk_online-programs_instructors/meta';
export * as quizzes from '@wix/auto_sdk_online-programs_quizzes/meta';
export * as onlineProgramParticipants from '@wix/auto_sdk_online-programs_online-program-participants/meta';
export * as participants from '@wix/auto_sdk_online-programs_participants/meta';
export * as programs from '@wix/auto_sdk_online-programs_programs/meta';
export * as sections from '@wix/auto_sdk_online-programs_sections/meta';
export * as steps from '@wix/auto_sdk_online-programs_steps/meta';
